<style lang="scss" scoped>
.slide-11 {
  background-image: url(../../../assets/module2/slide11/background-01.jpg);
  background-position: center;
  background-size: cover;
  padding-top: 80px;
  height: calc(100% - 80px);

  .pages {
    padding-top: 60px;
  }

  .page-right {
    z-index: 10;
  }

  .heading1 {
    color: #edad0a;
    width: 100%;
    text-align: center;
    font-size: 68px;
    transform: rotate(-3deg);
  }
  .heading2 {
    color: #c5d43b;
    font-size: 40px;
    width: 700px;
  }
  .heading3 {
    color: #3b7fc2;
    font-size: 40px;
  }
  .heading4 {
    color: #c5d43b;
    font-size: 40px;
  }
  .heading5 {
    color: #edad0a;
    margin-bottom: 30px;
    font-size: 40px;
  }
  p {
    color: #000;
    margin-bottom: 30px;
  }

  .drag {
    display: flex;
    flex-direction: row;
    padding: 20px 0;

    .drag-button {
      flex-basis: 30%;
      margin-left: -60px;
      max-width: 32%;
    }
    .labels {
      position: relative;
      flex-basis: 70%;
      height: 260px;

      > * {
        cursor: pointer;
        position: absolute;
        width: 180px;
      }
    }

    .happy {
      top: 0;
      left: 80px;
      &.straight img {
        transform: rotate(12deg);
      }
    }
    .angry {
      top: 0;
      right: 0;
      &.straight img {
        transform: rotate(-3deg);
      }
    }
    .silly {
      top: 80px;
      left: 0;
      &.straight img {
        transform: rotate(7deg);
      }
    }
    .unwell {
      top: 80px;
      left: 45%;
      &.straight img {
        transform: rotate(-5deg);
      }
    }
    .surprise {
      bottom: 0;
      left: 80px;
      &.straight img {
        transform: rotate(-5deg);
      }
    }
    .sad {
      bottom: 0;
      right: 0;
      &.straight img {
        transform: rotate(7deg);
      }
    }
  }
  .copy-wrapper {
    display: flex;
    flex-direction: row;

    p,
    div {
      display: inline-block;
    }

    .high-five-ellipse {
      width: 150px;
      height: 150px;
      display: inline-block;
    }
    .high-five {
      transform: scale(2);
      cursor: pointer;
    }
  }

  video {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    height: 100%;
    z-index: 20;
    box-shadow: 0px 0px 0px 100vw rgba(0, 0, 0, 0.9);
    z-index: 19999;
  }
}
</style>

<template>
  <div class="slide-11">
    <transition name="fadeUp" appear>
      <video
        v-if="showVid"
        ref="video"
        autoplay
        src="@/assets/highfive.mp4"
      ></video>
    </transition>
    <transition name="fadeUp" appear>
      <h1
        v-show="slideIndex == 10"
        class="heading1 delay-1"
        v-html="$t('module2.slide11.heading1')"
      ></h1>
    </transition>

    <div class="pages">
      <div class="page page-left">
        <transition name="fadeUp" appear>
          <h1 v-show="slideIndex == 10" class="heading2 delay-1">
            {{ $t("module2.slide11.heading2") }}
            <span
              class="heading3"
              v-html="$t('module2.slide11.heading3')"
            ></span>

            {{ $t("module2.slide11.heading4") }}
          </h1>
        </transition>
        <transition name="scale" appear>
          <div class="drag dealy-2" v-show="slideIndex == 10">
            <img
              src="@/assets/module2/slide11/drag_drop.svg"
              class="delay-4 drag-button"
            />
            <div class="labels">
              <div
                class="drag happy"
                v-drag1
                @mouseup.prevent="e => straighten(e)"
              >
                <img src="@/assets/module2/slide11/happy.png" />
              </div>
              <div
                class="drag angry"
                v-drag2
                @mouseup.prevent="e => straighten(e)"
              >
                <img src="@/assets/module2/slide11/angry.png" />
              </div>
              <div
                class="drag silly"
                v-drag3
                @mouseup.prevent="e => straighten(e)"
              >
                <img src="@/assets/module2/slide11/silly.png" />
              </div>
              <div
                class="drag unwell"
                v-drag4
                @mouseup.prevent="e => straighten(e)"
              >
                <img src="@/assets/module2/slide11/unwell.png" />
              </div>
              <div
                class="drag surprise"
                v-drag5
                @mouseup.prevent="e => straighten(e)"
              >
                <img src="@/assets/module2/slide11/surprise.png" />
              </div>
              <div
                class="drag sad"
                v-drag6
                @mouseup.prevent="e => straighten(e)"
              >
                <img src="@/assets/module2/slide11/sad.png" />
              </div>
            </div>
          </div>
        </transition>
      </div>

      <div class="page page-right">
        <div>
          <transition name="fadeRight" appear>
            <div class="copy-wrapper delay-2" v-show="slideIndex == 10">
              <p class="copy1" v-html="$t('module2.slide11.copy1')"></p>
              <div>
                <img
                  v-show="slideIndex == 10"
                  src="@/assets/module2/slide11/high_five_ellipse.png"
                  class="delay-4 high-five-ellipse"
                  v-drag7
                />
              </div>
            </div>
          </transition>
          <transition name="fadeRight" appear>
            <h2
              v-show="slideIndex == 10"
              class="heading5 delay-3"
              v-html="$t('module2.slide11.heading5')"
            ></h2>
          </transition>
          <transition name="fadeRight" appear>
            <div class="copy-wrapper delay-4" v-show="slideIndex == 10">
              <p class="copy2" v-html="$t('module2.slide11.copy2')"></p>
              <div>
                <img
                  v-show="slideIndex == 10"
                  src="@/assets/module2/slide11/high_five.svg"
                  class="delay-4 high-five"
                  @click.prevent="play()"
                />
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>

    <div class="cards">
      <transition name="fadeUp" appear>
        <img
          v-show="slideIndex == 10"
          src="@/assets/module2/slide11/text_boxes-01.png"
          class="chars delay-3"
        />
      </transition>
    </div>
  </div>
</template>

<script>
import gsap from "gsap";
import Draggable from "gsap/Draggable";

export default {
  props: ["slideIndex"],
  data() {
    return {
      droppableInstance: false,
      point1: false,
      point2: false,
      point3: false,
      point4: false,
      point5: false,
      point6: false,
      point7: false,
      showVid: false
    };
  },
  directives: {
    drag1: {
      inserted(el, binding, vnode) {
        console.log(binding);
        let _this = vnode.context;
        gsap.registerPlugin(Draggable);
        let x = 358;
        let y = 512;
        Draggable.create(el, {
          type: "x,y",
          liveSnap: {
            points: function(point) {
              var dx = point.x - x;
              var dy = point.y - y;
              if (Math.sqrt(dx * dx + dy * dy) < 100) {
                return { x: x, y: y };
              }
              return point;
            }
          },
          onDragEnd: function() {
            if (this.endX == x && this.endY == y) {
              _this.straighten(el);
              _this.point1 = true;
              _this.play();
            }
          }
        });
      }
    },
    drag2: {
      inserted(el, binding, vnode) {
        console.log(binding);
        let _this = vnode.context;
        gsap.registerPlugin(Draggable);
        let x = 368;
        let y = 525;
        Draggable.create(el, {
          type: "x,y",
          liveSnap: {
            points: function(point) {
              var dx = point.x - x;
              var dy = point.y - y;
              if (Math.sqrt(dx * dx + dy * dy) < 100) {
                return { x: x, y: y };
              }
              return point;
            }
          },
          onDragEnd: function() {
            if (this.endX == x && this.endY == y) {
              _this.straighten(el);
              _this.point2 = true;
              _this.play();
            }
          }
        });
      }
    },
    drag3: {
      inserted(el, binding, vnode) {
        console.log(binding);
        let _this = vnode.context;
        gsap.registerPlugin(Draggable);
        let x = 150;
        let y = 440;
        Draggable.create(el, {
          type: "x,y",
          liveSnap: {
            points: function(point) {
              var dx = point.x - x;
              var dy = point.y - y;
              if (Math.sqrt(dx * dx + dy * dy) < 100) {
                return { x: x, y: y };
              }
              return point;
            }
          },
          onDragEnd: function() {
            if (this.endX == x && this.endY == y) {
              _this.straighten(el);
              _this.point3 = true;
              _this.play();
            }
          }
        });
      }
    },
    drag4: {
      inserted(el, binding, vnode) {
        console.log(binding);
        let _this = vnode.context;
        gsap.registerPlugin(Draggable);
        let x = 1059;
        let y = 443;
        Draggable.create(el, {
          type: "x,y",
          liveSnap: {
            points: function(point) {
              var dx = point.x - x;
              var dy = point.y - y;
              if (Math.sqrt(dx * dx + dy * dy) < 100) {
                return { x: x, y: y };
              }
              return point;
            }
          },
          onDragEnd: function() {
            if (this.endX == x && this.endY == y) {
              _this.straighten(el);
              _this.point4 = true;
              _this.play();
            }
          }
        });
      }
    },
    drag5: {
      inserted(el, binding, vnode) {
        console.log(binding);
        let _this = vnode.context;
        gsap.registerPlugin(Draggable);
        let x = 937;
        let y = 374;
        Draggable.create(el, {
          type: "x,y",
          liveSnap: {
            points: function(point) {
              var dx = point.x - x;
              var dy = point.y - y;
              if (Math.sqrt(dx * dx + dy * dy) < 100) {
                return { x: x, y: y };
              }
              return point;
            }
          },
          onDragEnd: function() {
            if (this.endX == x && this.endY == y) {
              _this.straighten(el);
              _this.point5 = true;
              _this.play();
            }
          }
        });
      }
    },
    drag6: {
      inserted(el, binding, vnode) {
        console.log(binding);
        let _this = vnode.context;
        gsap.registerPlugin(Draggable);
        let x = -500;
        let y = 375;
        Draggable.create(el, {
          type: "x,y",
          liveSnap: {
            points: function(point) {
              var dx = point.x - x;
              var dy = point.y - y;
              if (Math.sqrt(dx * dx + dy * dy) < 100) {
                return { x: x, y: y };
              }
              return point;
            }
          },
          onDragEnd: function() {
            if (this.endX == x && this.endY == y) {
              _this.straighten(el);
              _this.point6 = true;
              _this.play();
            }
          }
        });
      }
    },
    drag7: {
      inserted(el, binding, vnode) {
        console.log(binding);
        let _this = vnode.context;
        gsap.registerPlugin(Draggable);
        let x = -70;
        let y = 500;
        Draggable.create(el, {
          type: "x,y",
          liveSnap: {
            points: function(point) {
              var dx = point.x - x;
              var dy = point.y - y;
              if (Math.sqrt(dx * dx + dy * dy) < 100) {
                return { x: x, y: y };
              }
              return point;
            }
          },
          onDragEnd: function() {
            if (this.endX == x && this.endY == y) {
              _this.straighten(el);
              _this.point7 = true;
              _this.play();
              // _this.point3 = true;
            }
          }
        });
      }
    }
  },
  mounted() {},

  methods: {
    play() {
      if (
        !(
          this.point1 &&
          this.point2 &&
          this.point3 &&
          this.point4 &&
          this.point5 &&
          this.point6 &&
          this.point7
        )
      )
        return;
      this.showVid = true;
      this.$nextTick(() => {
        if (this.$refs.video) {
          this.$refs.video.addEventListener(
            "ended",
            () => {
              this.showVid = false;
            },
            false
          );
        }
      });
    },
    straighten: e => {
      e.classList.add("straight");
    }
  }
};
</script>
